import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
	selector: "simple-modal",
	template: `
		<modal (close)="close()">
			<header class="modal_header">
				<h2>{{titleContent}}</h2>
			</header>
			<div class="modal_body">
				<ng-content></ng-content>
			</div>
			<footer class="modal_footer">
				<div class="modal_buttons">
					<button class="button button-primary" (click)="close()">Close</button>
				</div>
			</footer>
		</modal>
	`,
})
export class SimpleModal {
	@Input("title") titleContent: String;
	@Output("close") closed = new EventEmitter();

	close() {
		this.closed.emit();
	}
}
